const state = {
    ledgerConfigMenus: [],
    ledgerConfigExcludeMenus: []
}

const mutations = {
    ledgerConfigMenus (state, payload) {
        state.ledgerConfigMenus = payload
    },
    ledgerConfigExcludeMenus (state, payload) {
        state.ledgerConfigExcludeMenus = payload
    }
}

// 模块方式注册
export const LedgerConfig = {
    namespaced: true,
    state,
    mutations
}
